import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo-link" aria-label="YesNeDni — Accueil">
            <img
              src={`${process.env.PUBLIC_URL}/logo/ynd-monogram-gold-png-transparent.png`}
              alt=""
              className="footer-logo"
            />
            <span className="footer-brand-name">YesNeDni</span>
          </Link>
          <p>L'infrastructure intelligente de circulation du capital humain en Algérie.</p>
        </div>

        <div className="footer-links">
          <h4>Écosystème</h4>
          <Link to="/opportunites">Opportunités</Link>
          <Link to="/masterclasses">Savoirs</Link>
          <Link to="/mentors">Mentors</Link>
        </div>

        <div className="footer-links">
          <h4>Compte</h4>
          <Link to="/inscription">S'inscrire</Link>
          <Link to="/login">Connexion</Link>
          <Link to="/profil">Mon profil</Link>
        </div>

        <div className="footer-links">
          <h4>Contact</h4>
          <a href="mailto:contact@yesnedni-dz.com">contact@yesnedni-dz.com</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} YesNeDni. Tous droits réservés.</p>
      </div>
    </footer>
  );
}
